import {
	GET_PORT_MIRROR,
	GET_PORT_MIRROR_FAIL,
	GET_PORT_MIRROR_SUCCESS,
	RESET_UPDATE_PORT_MIRROR,
	UPDATE_PORT_MIRROR,
	UPDATE_PORT_MIRROR_FAIL,
	UPDATE_PORT_MIRROR_SUCCESS,
} from '../../constants/switchConfiguration/portMirroringConstants';

/**
 * Reducer function for managing switch port mirror list.
 *
 * @param {object} state - Current state of the switch port mirror list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const portMirrorReducer = (state = { portMirrorData: [] }, action) => {
	switch (action.type) {
		case GET_PORT_MIRROR:
			return {
				...state,
				loading: true,
			};
		case GET_PORT_MIRROR_SUCCESS:
			return {
				...state,
				loading: false,
				portMirrorData: action.payload,
			};
		case GET_PORT_MIRROR_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const updatePortMirroringReducer = (
	state = { successMessage: null, errorMessage: null },
	action
) => {
	switch (action.type) {
		case UPDATE_PORT_MIRROR:
			return {
				...state,
				loading: true,
			};
		case UPDATE_PORT_MIRROR_SUCCESS:
			return {
				...state,
				loading: false,
				successMessage: action.payload,
			};
		case UPDATE_PORT_MIRROR_FAIL:
			return {
				...state,
				loading: false,
				errorMessage: action.payload,
			};
		case RESET_UPDATE_PORT_MIRROR:
			return {
				...state,
				loading: false,
				errorMessage: null,
				successMessage: null,
			};
		default:
			return state;
	}
};
